(function () {
  const calcMinHeight = () => {
    const facetsTop = document.querySelector('.facets__top');
    const sortWrapper = document.querySelector('.facets__sort-wrapper');
    const collectionWrapper = document.querySelector('.collection-wrapper');

    if (facetsTop && sortWrapper && collectionWrapper) {
      const sortHeight = `${sortWrapper.getBoundingClientRect().height}px`;
      const banner = collectionWrapper.querySelector('.collection-horizontal-banner');

      if (banner && collectionWrapper.classList.contains('collection-wrapper--has-banner')) {
        const bannerStyles = getComputedStyle(banner);
        const bannerRow =
          banner.getBoundingClientRect().height + (parseFloat(bannerStyles.marginBottom) || 0);
        collectionWrapper.style.gridTemplateRows = `${bannerRow}px ${sortHeight} auto 1fr`;
        sortWrapper.style.top = `${bannerRow}px`;
      } else {
        collectionWrapper.style.gridTemplateRows = `${sortHeight} auto 1fr`;
        sortWrapper.style.top = '';
      }
    }
  }

  const resizeCollectionGrid = () => {
		const collectionGridSection = document.querySelector('.collection-grid-section') || document.querySelector('.section-search');

		const sectionResizeObserver = new ResizeObserver((entries) => {

			const [entry] = entries;
      calcMinHeight();
		});

		sectionResizeObserver.observe(collectionGridSection);
	}

  document.addEventListener('shopify:section:load', function () {
		resizeCollectionGrid();
	});

	resizeCollectionGrid();

    
})();